import React from 'react';
import { withSvgIcon } from './SvgIcon';

export const LinkedInIcon = withSvgIcon((props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24.952" height="24.975" viewBox="0 0 24.952 24.975"
    {...props}
  >
  <path id="linkedin" d="M.816,24.975V8.387H5.64V24.975Zm19.312-.009V15.923c0-1.856-.52-3.71-2.638-3.71a3.887,3.887,0,0,0-3.805,3.757v9H8.842V8.329h4.843v2.307a7.15,7.15,0,0,1,5.922-2.827c2.342,0,5.345,1.2,5.345,7.744v9.413ZM0,2.929A3.043,3.043,0,0,1,3.144,0,3.045,3.045,0,0,1,6.29,2.929,3.044,3.044,0,0,1,3.144,5.858,3.042,3.042,0,0,1,0,2.929Z"/>
</svg>
))